/**
 * pack-builder-collection-list.js
 *
 * Responsabilités :
 *   • Gérer les onglets de navigation entre collections.
 *   • Afficher / masquer les panneaux de produits correspondants.
 *
 * Aucune dépendance sur la sélection — pas besoin de web component,
 * ce module s'initialise une fois que le DOM est prêt (les scripts
 * `type="module"` sont différés par le navigateur).
 */

/**
 * Active un onglet et affiche le panneau correspondant dans le pack-builder parent.
 * @param {HTMLElement} packBuilder
 * @param {string | undefined} handle
 */
function selectCollection(packBuilder, handle) {
  if (!handle) return;

  for (const tab of packBuilder.querySelectorAll('[data-collection-tab]')) {
    if (!(tab instanceof HTMLButtonElement)) continue;
    const isSelected = tab.dataset.collectionTab === handle;
    tab.classList.toggle('is-active', isSelected);
    tab.setAttribute('aria-selected', String(isSelected));
  }

  for (const panel of packBuilder.querySelectorAll('[data-collection-panel]')) {
    panel.toggleAttribute('hidden', panel.dataset.collectionPanel !== handle);
  }
}

/**
 * Attache les listeners sur une nav `.pack-builder-collection-list`.
 * @param {HTMLElement} nav
 */
function initCollectionList(nav) {
  const packBuilder = nav.closest('pack-builder');
  if (!(packBuilder instanceof HTMLElement)) return;

  for (const tab of nav.querySelectorAll('[data-collection-tab]')) {
    if (!(tab instanceof HTMLButtonElement)) continue;
    tab.addEventListener('click', () => selectCollection(packBuilder, tab.dataset.collectionTab));
  }

  // Sélectionner l'onglet actif au chargement (ou le premier)
  const active = nav.querySelector('[data-collection-tab].is-active');
  const first = nav.querySelector('[data-collection-tab]');
  const initial = active instanceof HTMLButtonElement ? active : first instanceof HTMLButtonElement ? first : null;
  selectCollection(packBuilder, initial?.dataset.collectionTab);
}

// Les scripts `type="module"` s'exécutent après le parsing HTML complet.
for (const nav of document.querySelectorAll('.pack-builder-collection-list')) {
  if (nav instanceof HTMLElement) initCollectionList(nav);
}
